module.exports = __webpack_public_path__ + "static/media/vrOncologyManagement.d5f387af.jpg";